"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacings = void 0;
exports.spacings = {
    xxxs: "0.125rem",
    xxs: "0.25rem",
    xs: "0.5rem",
    s: "0.75rem",
    m: "1rem",
    l: "1.25rem",
    xl: "1.5rem",
    xxl: "1.75rem",
    xxl2: "2.5rem"
};
//# sourceMappingURL=spacings.js.map